<template>
    <div class="template-item" :class="{'pointer':type=='select'}">
        <div class="active-box" v-if="type=='select'">
            <i class="icon-gouxuan"></i>
        </div>
        <div>
            <div class="title">{{item.title}}</div>
            <div class="desc" v-if="item.color">
                <div class="demo-text" :style="{color:item.color.firstColor}">{{item.first}}</div>
                <div class="demo-text" v-if="item.keyword1">
                    {{item.keyword1Const}}: <span :style="{color:item.color.keyword1Color}">{{item.keyword1}}</span>
                </div>
                <div class="demo-text" v-if="item.keyword2">
                    {{item.keyword2Const}}: <span :style="{color:item.color.keyword2Color}">{{item.keyword2}}</span>
                </div>
                <div class="demo-text" v-if="item.keyword3">
                    {{item.keyword3Const}}: <span :style="{color:item.color.keyword3Color}">{{item.keyword3}}</span>
                </div>
                <div class="demo-text" v-if="item.keyword4">
                    {{item.keyword4Const}}: <span :style="{color:item.color.keyword4Color}">{{item.keyword4}}</span>
                </div>
                <div class="demo-text" v-if="item.keyword5">
                    {{item.keyword5Const}}: <span :style="{color:item.color.keyword5Color}">{{item.keyword5}}</span>
                </div>
                <div class="demo-text" :style="{color:item.color.remarkColor}">消息备注：{{item.remark}}</div>
            </div>
        </div>
        <div class="info-box" v-if="type!='look'">
            <div class="time" v-if="item.updateTime||item.createTime">更新于 {{(item.updateTime||item.createTime)|formatDate("yyyy年MM月dd日")}}</div>
            <div v-if="!type">
                <i class="icon-bianji" @click="edit(item)"></i>
                <i class="icon-shanchu" @click="del(item)"></i>
            </div>
        </div>
    </div>
</template>
<script>
    //当前实例组件
    export default {
        props:{
            type:null,
            item:null
        },
        data: () => ({

        }),
        components: {},
        mounted() {

        },
        methods: {
            edit(item){
                this.$emit("edit",item);
            },
            del(item){
                this.$confirm(
                    '确认删除模板？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                .then(()=> {
                    this.$http({
                        url:'/wechatthirdplat/standardTemplate',
                        type:'delete',
                        params: {ids:item.id},
                    }).then((data)=> {
                        this.$emit("reload");
                        this.$message.success('删除成功');
                    });
                })

            }
        },
    };
</script>
<style lang="scss">
.template-item {
    padding: 20px 15px;
    width: 100%;
    background-color: #fff;
    margin-bottom: 15px;
    &.pointer {
        cursor: pointer;
    }
    .title {
        font-size: 16px;
        margin-bottom: 15px;
    }
    .desc {
        color: #000;
    }
    .info-box {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #999;
        i {
            font-size: 20px;
            cursor: pointer;
        }
        .icon-bianji {
            font-size: 18px;
        }
    }
}
</style>
